import React from 'react';
import PropTypes from 'prop-types';
import distanceImage from '../../../../assets/images/position.png';

const format = (distance) => {
  if (distance > 100) return '>100';
  if (distance > 10) return distance.toFixed();

  return distance.toFixed(2);
};

const Distance = ({ distance }) => {
  if (!distance) return null;

  return (
    <div className="c-distance-marker u-pin-top-right u-mt--">
      <img src={distanceImage} alt="" />
      <span>{format(distance)} mi</span>
    </div>
  );
};
Distance.propTypes = {
  distance: PropTypes.number,
};
Distance.defaultProps = {
  distance: 0,
};

export default Distance;



// WEBPACK FOOTER //
// ./src/app/shops/components/Distance.jsx